import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/aceites/tapa_aceite.webp")